export const getFileHash = async (file) => {
  const arrayBuffer = await file.arrayBuffer() // Read file as an ArrayBuffer
  const hashBuffer = await crypto.subtle.digest("SHA-256", arrayBuffer) // Hash it
  const hashArray = Array.from(new Uint8Array(hashBuffer)) // Convert buffer to byte array
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("") // Convert to hex
  return hashHex
}
